import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as auth from 'core/auth';
import * as api from 'core/api';
import * as orders from 'core/orders';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountProductsBuyComponent extends Vue {
    $auth: auth.AuthService;

    view = 'loading';

    orders: orders.OrderModel[] = [];

    mounted() {
        this.$auth.ordersList().then(
            (result: api.ReservationStatusResult[]) => {
                if (result?.length > 0) {
                    this.orders = new orders.OrderService().convertToOrders(result);
                }

                this.view = 'view';
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    getOrderNumber(order: api.ReservationStatusResult) {
        return i18next.t('label_with_number', { i: order.reservationInfo.reservationNumber });
    }

    getOrderProductsUrl(order: api.ReservationStatusResult) {
        return '/account/products/buy/' + order.reservationInfo.reservationPublicId;
    }
}
